import { createApp } from "vue";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import { amplifyConfigure } from "./utils/auth";
import i18n from "./utils/i18n";

import "bootstrap";
import "bootstrap/scss/bootstrap.scss";
import "animate.css";
import "./assets/css/style.css";
import "./assets/css/transition.css";

amplifyConfigure(
  process.env.VUE_APP_REGION_NAME,
  process.env.VUE_APP_COGNITO_USER_POOL_ID,
  process.env.VUE_APP_COGNITO_CLIENT_ID,
);

const randomString = () => (
  Math.random()
    .toString(36)
    .substr(2, 6)
);

const app = createApp(App);

app.use(store);
app.use(router);
app.mixin({
  methods: {
    randomString,
  },
});
app.use(i18n);

app.config.errorHandler = (err, vm, info) => {
  // エラーハンドリング
  console.log(err);
  console.log(vm);
  console.log(info);
  alert("グローバルエラー");
  // router.push({ name: "ErrorPage", params: { errorId: "500" } });
};

app.mount("#app");
